import { createAction, createSlice } from "@reduxjs/toolkit";

const getPopularInstructorSlice = createSlice({
  name: "getPopularInstructor",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      const { data, pagination } = action.payload;
      state.data = data;
      state.pagination = pagination;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = getPopularInstructorSlice;
const getPopularInstructorAction = createAction(name);

export {
  getPopularInstructorAction,
  actions as getPopularInstructorActions,
  reducer as getPopularInstructorReducer,
};
